import { APP_ROUTES } from "~/constants/appRoutes";
import { resolveHomeTab } from "~/constants/HomeTabs";
import { getBrowserPathname, getBrowserSearch } from "~/utils/browserHostname";

// `overrides` covers events sent before router.push/replace updates the URL
export function getPagePath(overrides: { tab?: string } = {}): string {
    const pathname = getBrowserPathname();
    if (pathname !== APP_ROUTES.HOME) {
        return pathname;
    }

    const tab = overrides.tab ?? new URLSearchParams(getBrowserSearch()).get("tab");
    return `${pathname}?tab=${resolveHomeTab(tab)}`;
}
